import script from "./OpenPrivateInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenPrivateInfoView.vue?vue&type=script&setup=true&lang=js"

import "./OpenPrivateInfoView.vue?vue&type=style&index=0&id=489ad829&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489ad829"]])

export default __exports__